const dev = {
  API_ENDPOINT_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001',
  WS_ENDPOINT_URL: process.env.REACT_APP_WS_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001',
  PROPERTIES_SITE_URL: process.env.REACT_APP_PROPERTIES_SITE_URL || 'https://properties.mare-realty.com'
};

const prod = {
  API_ENDPOINT_URL: process.env.REACT_APP_BACKEND_URL || 'https://api.sistema.mare-realty.com',
  WS_ENDPOINT_URL: process.env.REACT_APP_WS_URL || process.env.REACT_APP_BACKEND_URL || 'https://api.sistema.mare-realty.com',
  PROPERTIES_SITE_URL: process.env.REACT_APP_PROPERTIES_SITE_URL || 'https://properties.mare-realty.com'
};

const test = {
  API_ENDPOINT_URL: process.env.REACT_APP_BACKEND_URL || '/api',
  WS_ENDPOINT_URL: process.env.REACT_APP_WS_URL || '',
  PROPERTIES_SITE_URL: process.env.REACT_APP_PROPERTIES_SITE_URL || 'https://properties.mare-realty.com'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
